import {setupAjaxConfiguration} from "ajaxSetup";
import i18n from "l10n";
import dhtmlx from "dhtmlxAdapter";
import router from 'routers/dashboard.router';

require('js/traits/google-analytics');

setupAjaxConfiguration(router).then(() => console.log("Ajax setup done."));
const getUrlVars = function () {
    const vars = {};
    window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
        vars[key] = value;
    });
    return vars;
};
const urlVars = getUrlVars();
const statusMsg = urlVars["status"];
if (statusMsg) {
    if (statusMsg.toLowerCase() === "CANCELED".toLowerCase()) {
        dhtmlx.alert({
            text: i18n.t("credits.cardcanceled"),
            callback: function () {
                window.location.href = "Dashboard.htm";
            }
        });
    } else if (statusMsg.toLowerCase() === "REFUSED".toLowerCase()) {
        dhtmlx.alert({
            text: i18n.t("credits.cardrefused"),
            callback: function () {
                window.location.href = "Dashboard.htm";
            }
        });
    } else if (statusMsg.toLowerCase() === "ERROR".toLowerCase()) {
        dhtmlx.alert({
            text: i18n.t("credits.carderror"),
            callback: function () {
                window.location.href = "Dashboard.htm";
            }
        });
    }
}
const amount = urlVars["amount"];
const credits = urlVars["credits"];
const payType = urlVars["pay_type"];
const accountType = urlVars["accountType"];
const months = urlVars["months"];
if (payType) {
    if (payType === 'upgrade') {
        dhtmlx.alert({
            text: i18n.t("credits.upgradesuccess", {
                amount: amount,
                accountType: accountType,
                count: parseInt(months)
            }),
            callback: function () {
                window.location.href = "Dashboard.htm";
            }
        });
    } else if (payType === 'expand') {
        dhtmlx.alert({
            text: i18n.t("credits.expandsuccess", {
                amount: amount,
                accountType: accountType,
                count: parseInt(months)
            }),
            callback: function () {
                window.location.href = "Dashboard.htm";
            }
        });
    }
} else if (amount && credits) {
    var roundedAmount = Math.floor(amount) + (Math.floor((amount * 100) % 100) / 100);
    dhtmlx.alert({
        text: i18n.t("credits.purchasesuccessamount", {count: roundedAmount}) +
            " " + i18n.t("credits.purchasesuccesscredits", {count: parseInt(credits)}),
        callback: function () {
            window.location.href = "Dashboard.htm";
        }
    });
}